// extracted by mini-css-extract-plugin
export default {"chip":"Chip_chip__I6jzt","title":"Chip_title__9nEQB","icon":"Chip_icon__qh9HA"};